import axios from '../../axios'

// 院校排名管理端接口

// 新增院校排名
export const addSchoolRank = (data) => {
    return axios({
        url: '/api/data/wish/rank',
        method: 'POST',
        data
    })
}

// 获取院校排名详情
export const getSchoolRankInfo = (data) => {
    return axios({
        url: '/api/data/wish/rank/info',
        method: 'GET',
        data
    })
}

// 修改院校排名信息
export const editSchoolRank = (data) => {
    return axios({
        url: '/api/data/wish/rank',
        method: 'PUT',
        data
    })
}

// 删除院校排名信息
export const deleteSchoolRank = (data) => {
    return axios({
        url: '/api/data/wish/rank',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索院校排名信息列表
export const searchSchoolRankList = (data) => {
    return axios({
        url: '/api/data/wish/rank',
        method: 'GET',
        data
    })
}

// 根据信息综合搜索院校排名信息列表
export const searchCategoryList = (data) => {
    return axios({
        url: '/api/data/wish/rankcategory',
        method: 'GET',
        data
    })
}

// 导入院校排名
export const importSchoolRank = (data) => {
    return axios({
        url: '/api/data/wish/rank/import',
        method: 'POST',
        data
    })
}

// 导出院校排名
export const exportSchoolRank = (data) => {
    return axios({
        url: '/api/data/wish/rank/export',
        method: 'POST',
        data
    })
}

// 批量更新院校排名
export const updateSchoolRank = (data) => {
    return axios({
        url: '/api/data/wish/rank/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除院校排名
export const queryDelSchoolRank = (data) => {
    return axios({
        url: '/api/data/wish/rank/batch/delete',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/schoolrank.js